export default {
  name: "CalendarSuccess",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 5h-4V3c0-.55-.45-1-1-1s-1 .45-1 1v2H10V3c0-.55-.45-1-1-1s-1 .45-1 1v2H4c-1.16 0-2 .84-2 2v21c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V7c0-1.16-.84-2-2-2zm0 23H4V7h4v1c0 .55.45 1 1 1s1-.45 1-1V7h12v1c0 .55.45 1 1 1s1-.45 1-1V7h4v21zm-13.11-5c-.23 0-.45-.08-.63-.22L9.37 18.8a1 1 0 1 1 1.27-1.55l4.08 3.32 5.49-7.26a1 1 0 0 1 1.4-.19 1 1 0 0 1 .19 1.4l-6.11 8.08a.97.97 0 0 1-.8.4z",
  },
}
